

















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Analysis } from "@/api/analyses/types";

@Component({
  name: "FarmOwnerInfo",
})
export default class FarmOwnerInfo extends Vue {
  @Prop({ type: Object, required: true })
  private analysis!: Analysis;

  get farmRegion() {
    if (this.analysis) {
      return [
        this.analysis.city,
        this.analysis.microRegion,
        this.analysis.state,
      ]
        .filter((v) => !!v)
        .join(" / ");
    }
    return "";
  }
}
